module.exports = __webpack_public_path__ + "static/media/zelinskyCollectionDvd01.870ec796.jpg";